import {
  booleanAttribute,
  Component,
  HostBinding,
  input,
  output,
} from '@angular/core';
import { InputBase } from '../base/input-base';

type InputIconPosition = 'left' | 'right';
@Component({
  selector: 'app-input-icon',
  styleUrl: './input-icon.component.scss',
  templateUrl: './input-icon.component.html',
  host: {
    class: 'grid grid-cols-12',
  },
})
export class InputIconComponent extends InputBase {
  icon = input('search');
  position = input<InputIconPosition>('right');
  helperText = input<string>();
  label = input();
  placeholder = input('');
  fullWidth = input(false, { transform: booleanAttribute });

  inputChange = output<string>();

  onInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.inputChange.emit(value);
    this?.onChange(value);
    this.value = value;
  }

  writeValue(value: unknown): void {
    this.value = value?.toString() ?? '';
  }

  @HostBinding('class')
  get hostClass() {
    let hostClassName = '';

    if (this.fullWidth()) {
      hostClassName += 'full-width ';
    }

    return hostClassName;
  }
}
